import PropTypes from 'prop-types'

export default PropTypes.shape({
  cargoOpsComplete: PropTypes.shape({
    actual: PropTypes.string,
    estimated: PropTypes.string,
  }).isRequired,
  scheduledDeparture: PropTypes.string,
})
